import React, { useEffect, useState } from "react";
import {
  FormInputStockOpname,
  RESET_STATE_STOCK_OPNAME,
  RenderSimpanButton,
  DaftarTidakDitemukan,
  DaftarGagal,
  getListItemByStockOpname,
  DaftarListItem,
} from "./ui";
import { STYLE_MASTER_GUDANG_UTAMA } from "App/Component/layout/Wms/MasterWms/MasterGudangUtama/ui";
import { Title } from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import { Grid, Paper } from "@material-ui/core";
import { BASE_URL_4, WMS_PBF_STOCK_OPNAME } from "App/constants";

function StockOpname({ menu, data }) {
  const classes = STYLE_MASTER_GUDANG_UTAMA();
  const [formData, setFormData] = useState(() => {
    if (isNull(menu)) {
      return RESET_STATE_STOCK_OPNAME;
    } else {
      if (menu === WMS_PBF_STOCK_OPNAME) {
        return data;
      } else {
        return RESET_STATE_STOCK_OPNAME;
      }
    }
  });

  useEffect(() => {
    if (!isNull(menu) && menu === WMS_PBF_STOCK_OPNAME) {
      setFormData(data);
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const [file, setFile] = useState(null);

  useEffect(() => {
    (async () => {
      if (!isNull(menu) && menu === WMS_PBF_STOCK_OPNAME) {
        await setNewAllDataID(data.id);
      }
    })();
  }, [data.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const [rowsTidakDitemukan, setRowsTidakDitemukan] = useState([]);
  const [rowsGagal, setRowsGagal] = useState([]);
  const [rowsListItem, setRowsListItem] = useState([]);
  const [loading, setLoading] = useState(false);

  async function setNewAllData() {
    setLoading(true);
    if (!isNull(formData.id)) {
      const res = await getListItemByStockOpname(formData.id);
      if (res.state) {
        setRowsListItem(res.data);
      } else {
        setRowsListItem([]);
      }
    }
    setLoading(false);
  }

  async function setNewAllDataID(id) {
    setLoading(true);
      const res = await getListItemByStockOpname(id);
      if (res.state) {
        setRowsListItem(res.data);
      } else {
        setRowsListItem([]);
      }
      setLoading(false);
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Title title='Stock Opname Stock Perbekalan Farmasi' />

        <div>
          {!isNull(formData.gudang_id) && (
            <a
              download
              style={{
                backgroundColor: "#F09F00",
                padding: "0.4rem 0.8rem",
                textDecoration: "none",
                color: "white",
                borderRadius: "4px",
                fontSize: "12px",
              }}
              rel='noopener noreferrer'
              href={`${BASE_URL_4}/wmsfarmasi/stockOpname/downloadStockByGudangId/${formData.gudang_id}`}
              target='_blank'>
              Download
            </a>
          )}
        </div>
      </div>

      <Paper
        style={{
          padding: "1rem",
        }}>
        <FormInputStockOpname
          formData={formData}
          setFormData={setFormData}
          file={file}
          setFile={setFile}
          setRowsTidakDitemukan={setRowsTidakDitemukan}
          setRowsGagal={setRowsGagal}
          setNewAllData={setNewAllData}
        />

        {!isNull(formData.id) && (
          <Grid container spacing={2}>
            <Grid item sm={6}>
              <DaftarTidakDitemukan rows={rowsTidakDitemukan} />
            </Grid>
            <Grid item sm={6}>
              <DaftarGagal rows={rowsGagal} />
            </Grid>
          </Grid>
        )}

        {!isNull(formData.id) && (
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <DaftarListItem rows={rowsListItem} loading={loading}/>
            </Grid>
          </Grid>
        )}
      </Paper>

      <RenderSimpanButton
        formData={formData}
        setFormData={setFormData}
        setNewAllData={setNewAllData}
      />
    </div>
  );
}

export default StockOpname;
